export enum Role {
  Admin = 0,
  Sampler = 1,
  Systems = 2,
  Reef = 3,
  Driver = 4,
  ClientRelations = 5,
  Engineer = 6,
  Scheduler = 7,
  Cloud = 8,
  Field = 9,
  POUFilters = 10,
  AI = 11,
  CloudSchedule = 12,
  CloudNonConformities = 13,
  CloudParentAccountView = 14,
  DevEnvironment = 15
}

export enum EditMode {
  None = "None",
  New = "New",
  Edit = "Edit",
  EditOutlet = "EditOutlet",
  EditWorkListItem = "EditWorkListItem",
  Photo = "Photo",
  EditSystem = "EditSystem",
  SampleResults = "SampleResults",
  RawSampleResults = "RawSampleResults",
  History = "History"
}

export enum SampleSetStatus {
  ToDo = "ToDo",
  SiteApproval = "Site Approval",
  AwaitingDropOff = "Awaiting Drop-off",
  Complete = "Complete"
}

export enum SampleStatus {
  ToDo = "ToDo",
  Done = "Done",
  NotTaken = "Not Taken"
}

export enum OutletStatus {
  OK = "OK",
  Covid = "Covid",
  RoomInUse = "Room in Use",
  NotWorking = "Not Working",
  Removed = "Removed",
  Other = "Other"
}

export enum OutletType {
  CT = "CT",
  HT = "HT",
  MT = "MT",
  Bath = "Bath",
  Bidet = "Bidet",
  Shower = "Shower",
  Tank = "Tank",
  HeatingSystem = "HeatingSystem",
  Softener = "Softener",
  ExpansionVessel = "ExpansionVessel",
  ClosedCircuitSystem = "ClosedCircuitSystem"
}

export enum TankShape {
  Rectangular = "Rectangular",
  Cube = "Cube",
  VerticalCylinder = "VerticalCylinder",
  HorizontalCylinder = "HorizontalCylinder"
}

export enum TankStatus {
  Online = "Online",
  Offline = "Offline"
}

export enum TankMaterial {
  BlackPlastic = "BlackPlastic",
  GRP = "GRP",
  MildSteel = "MildSteel",
  OtherUnsuitableMaterial = "OtherUnsuitableMaterial",
  Other = "Other"
}

export enum TankLocationType {
  Indoor = "Indoor",
  Outdoor = "Outdoor"
}

export enum PipeMaterial {
  Copper = "Copper",
  Steel = "Steel",
  Plastic = "Plastic",
  Lead = "Lead",
  Other = "Other"
}

export enum TankSwitchType {
  None = "None",
  Ballvalve = "Ballvalve",
  Keraflo = "Keraflo",
  SolenoidValve = "SolenoidValve",
  Level = "Level",
  Other = "Other"
}

export enum DisinfectionMethod {
  HardSurfaceSpray = "HardSurfaceSpray",
  FillAndSoak = "FillAndSoak"
}

export enum DisinfectantType {
  SodiumHypochlorite = "SodiumHypochlorite",
  ChlorineDioxide = "ChlorineDioxide",
  SilverStabilisedHydrogenPeroxide = "SilverStabilisedHydrogenPeroxide",
  Other = "Other"
}

export enum NeutralisingAgent {
  None = "None",
  SodiumThiosulphate = "SodiumThiosulphate",
  Other = "Other"
}

export enum TankConditionLevel {
  None = "None",
  Light = "Light",
  Moderate = "Moderate",
  Heavy = "Heavy"
}

export enum FlushType {
  None = "None",
  PreFlush = "Pre-Flush",
  PostFlush = "Post-Flush",
  Both = "Both"
}

export enum SampleClass {
  Primary = "Primary",
  Secondary = "Secondary",
  WaterQuality = "Water Quality",
  SelectedPrimary = "Selected Primary",
  TemporaryTest = "Temporary Test"
}

export enum SampleType {
  Cold = "COLD",
  Hot = "HOT",
  Blended = "BLENDED"
}

export enum AccessTime {
  One = "1",
  Two = "2",
  Three = "3"
}

export enum AssetType {
  Sampling = "Sampling",
  MaintenanceAndFailsafe = "MaintenanceAndFailsafe",
  ShowerCleans = "ShowerCleans",
  TemperatureMonitoring = "TemperatureMonitoring",
  Flushing = "Flushing",
  Tanks = "Tanks",
  HeatingSystems = "HeatingSystems",
  Softeners = "Softeners",
  ClosedCircuitSystems = "ClosedCircuitSystems",
  Disinfections = "Disinfections",
  ServiceReports = "ServiceReports",
  PointOfUseFilters = "PointOfUseFilters"
}

export enum OutletsFilterType {
  OutletNumbers = '0',
  Barcodes = '1',
  AssetsIDs = '2',
  Rooms = '3'
}

export enum WorkListType {
  Sampling = "Sampling",
  OrcaInstallation = "OrcaInstallation",
  OrcaCommissioning = "OrcaCommissioning",
  ServiceReport = "ServiceReport",
  OrcaRepair = "OrcaRepair",
  RayInstallation = "RayInstallation",
  RayCommissioning = "RayCommissioning",
  RayMaintenance = "RayMaintenance",
  RayRepair = "RayRepair",
  Flushing = "Flushing",
  Temperature = "Temperature",
  Failsafe = "Failsafe",
  ShowerClean = "ShowerClean",
  Maintenance = "Maintenance",
  LegionellaRiskAssessment = "LegionellaRiskAssessment",
  TmvServiceType2 = "TmvServiceType2",
  IndependentTechnicalReport = "IndependentTechnicalReport",
  TankInspection = "TankInspection",
  TankClean = "TankClean",
  TankCleanFillAndSoak = "TankCleanFillAndSoak",
  CalorifierInspection = "CalorifierInspection",
  CalorifierClean = "CalorifierClean",
  Blowdown = "Blowdown",
  ExpansionVesselFlushing = "ExpansionVesselFlushing",
  Disinfection = "Disinfection",
  LocalPipeworkDisinfection = "LocalPipeworkDisinfection",
  OutletDisinfection = "OutletDisinfection",
  ChlorineDioxideInstallation = "ChlorineDioxideInstallation",
  ChlorineDioxideServicing = "ChlorineDioxideServicing",
  ChlorineDioxideInspection = "ChlorineDioxideInspection",
  TemperatureAndChlorineDioxide = "TemperatureAndChlorineDioxide",
  SodiumHypochloriteInstallation = "SodiumHypochloriteInstallation",
  SodiumHypochloriteCommissioning = "SodiumHypochloriteCommissioning",
  SodiumHypochloriteServicing = "SodiumHypochloriteServicing",
  SodiumHypochloriteInspection = "SodiumHypochloriteInspection",
  SodiumHypochloriteMonitoring = "SodiumHypochloriteMonitoring",
  SilverStabilisedHydrogenPeroxideInstallation = "SilverStabilisedHydrogenPeroxideInstallation",
  SilverStabilisedHydrogenPeroxideCommissioning = "SilverStabilisedHydrogenPeroxideCommissioning",
  SilverStabilisedHydrogenPeroxideServicing = "SilverStabilisedHydrogenPeroxideServicing",
  SilverStabilisedHydrogenPeroxideInspection = "SilverStabilisedHydrogenPeroxideInspection",
  SilverStabilisedHydrogenPeroxideMonitoring = "SilverStabilisedHydrogenPeroxideMonitoring",
  GenoxInstallation = "GenoxInstallation",
  GenoxCommissioning = "GenoxCommissioning",
  GenoxServicing = "GenoxServicing",
  GenoxInspection = "GenoxInspection",
  GenoxMonitoring = "GenoxMonitoring",
  UvSystemInstallation = "UvSystemInstallation",
  UvSystemCommissioning = "UvSystemCommissioning",
  UvSystemServicing = "UvSystemServicing",
  UvSystemInspection = "UvSystemInspection",
  UvSystemMonitoring = "UvSystemMonitoring",
  WaterSoftenerInstallation = "WaterSoftenerInstallation",
  SoftenerService = "SoftenerService",
  WaterSoftenerMonitoring = "WaterSoftenerMonitoring",
  ClosedSystemSampling = "ClosedSystemSampling",
  ClosedSystemDosing = "ClosedSystemDosing",
  ClosedSystemFlushing = "ClosedSystemFlushing",
  EvaporativeCoolingSystemsInspection = "EvaporativeCoolingSystemsInspection",
  EvaporativeCoolingSystemsCleaningAndDisinfection = "EvaporativeCoolingSystemsCleaningAndDisinfection",
  RemedialWorks = "RemedialWorks",
  RemoteMonitoringInstallation = "RemoteMonitoringInstallation",
  AddPouFilter = "AddPouFilter",
  ReplacePouFilter = "ReplacePouFilter",
  RemovePouFilter = "RemovePouFilter",
  Other = "Other"
}

export enum TestFrequency {
  ThreeDays = "ThreeDays",
  Weekly = "Weekly",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Annually = "Annually"
}

export enum FilterOutletStatus {
  All = "All",
  OK = "Ok",
  OKAndNoAccess = "OKAndNoAccess"
}

export enum RequestStatus {
  Open = "Open",
  Closed = "Closed"
}

export enum TransactionCategory {
  OpeningBalance = "Opening Balance",
  Deposit = "Deposit",
  Withdrawal = "Withdrawal",
  StockCheck = "Stock Check",
  Scrap = "Scrap",
  DirectOrder = "Direct Order"
}

export enum ContractLineStatus {
  POReceived = "PO Received",
  Scheduled = "Scheduled",
  WorkComplete = "Work Complete",
  ReportSent = "Report Sent",
  InvoiceSent = "Invoice Sent"
}

export enum JobStatus {
  ProvisionallyScheduled = "ProvisionallyScheduled",
  Scheduled = "Scheduled",
  Notified = "Notified",
  SheetsCreated = "SheetsCreated",
  InProgress = "InProgress",
  Completed = "Completed",
  ReportSent = "ReportSent",
  Invoiced = "Invoiced",
  Off = "Off",
  OffNotPayable = "OffNotPayable",
  Cancelled = "Cancelled"
}

export enum JobFrequency {
  Weekly = "Weekly",
  Biweekly = "Biweekly",
  Monthly = "Monthly",
  Bimonthly = "Bimonthly",
  Quarterly = "Quarterly",
  SixMonthly = "SixMonthly",
  Yearly = "Yearly",
  OneOff = "OneOff"
}

export enum VisitType {
  Sampling = "Sampling",
  Maintenance = "Maintenance",
  MaintenanceAndSampling = "MaintenanceAndSampling",
  RayMaintenance = "RayMaintenance",
  SamplingAndReef = "SamplingAndReef",
  Reef = "Reef",
  Other = "Other"
}

export enum EnginnerCategory {
  CategoryA = "A",
  CategoryB = "B",
  CategoryC = "C"
}

export enum EventLogActionType {
  Create = "Create",
  Update = "Update",
  Delete = "Delete"
}

export enum EventLogSource {  
  Building = "Building",
  BuildingSystem = "BuildingSystem",
  Company = "Company",
  Contract = "Contract",
  Event = "Event",
  FileDirectory = "FileDirectory",
  Fleet = "Fleet",
  InterimLink = "InterimLink",
  Job = "Job",
  JobRule = "JobRule",
  Lab = "Lab",
  Mail = "Mail",
  NonConformity = "NonConformity",
  Outlet = "Outlet",
  ParentsAccount = "ParentsAccount",
  PriceList = "PriceList",
  Sample = "Sample",
  SampleSet = "SampleSet",
  SchedulerJobReports = "SchedulerJobReports",
  ServiceReport = "ServiceReport",
  Site = "Site",
  SiteBuilding = "SiteBuilding",
  SiteContact = "SiteContact",
  SiteNote = "SiteNote",
  SiteRules = "SiteRules",
  Stock = "Stock",
  StockAsset = "StockAsset",
  StockRequest = "StockRequest",
  StockTransaction = "StockTransaction",
  Template = "Template",
  TemplateOutlet = "TemplateOutlet",
  User = "User",
  VehicleCheck = "VehicleCheck",
  VehicleRepair = "VehicleRepair",
  WorkListItem = "WorkListItem",
  WorkListSet = "WorkListSet"
}

export enum IssueReason {
  NoAccessRoomInUse = "NoAccessRoomInUse",
  ElevatedColdTemperature = "ElevatedColdTemperature",
  NoAccessToIsolationTmv = "NoAccessToIsolationTmv",
  LocalIsolationValveFailureHot = "LocalIsolationValveFailureHot",
  LocalIsolationValveFailureCold = "LocalIsolationValveFailureCold",
  LocalIsolationValveFailureReturn = "LocalIsolationValveFailureReturn",
  UnableToAdjustTempHotInletDepressed = "UnableToAdjustTempHotInletDepressed",
  UnableToAdjustTempCartridgeFailure = "UnableToAdjustTempCartridgeFailure",
  DepressedReturnTemperature = "DepressedReturnTemperature",
  FailsafeTestFailure = "FailsafeTestFailure",
  UnableToRemoveTmvTmt = "UnableToRemoveTmvTmt",
  OutletHasBeenRemoved = "OutletHasBeenRemoved",
  NoAccessToPipework = "NoAccessToPipework",
  ElevatedHotTemperature = "ElevatedHotTemperature",
  DepressedHotTemperature = "DepressedHotTemperature",
  ElevatedMixedTemperature = "ElevatedMixedTemperature",
  DepressedMixedTemperature = "DepressedMixedTemperature",
  ExceedsChlorineDioxideUpperLimit = "ExceedsChlorineDioxideUpperLimit",
  BelowChlorineDioxideLowerLimit = "BelowChlorineDioxideLowerLimit",
  SamplingCopper = "SamplingCopper",
  SamplingSilver = "SamplingSilver",
  SamplingTVC = "SamplingTVC",
  SamplingTvc22 = "SamplingTvc22",
  SamplingTvc37 = "SamplingTvc37",
  SamplingLegionella = "SamplingLegionella",
  SamplingPseudomonasEcoliColiforms = "SamplingPseudomonasEcoliColiforms",
  SamplingPseudomonas = "SamplingPseudomonas",
  SamplingEcoli = "SamplingEcoli",
  SamplingTotalColiforms = "SamplingTotalColiforms",
  OutletIsolatedNotWorking = "OutletIsolatedNotWorking",
  NoAccessDeniedAccess = "NoAccessDeniedAccess",
  OutletBlocked = "OutletBlocked",
  OutletRemoved = "OutletRemoved",
  TankOfflineNotDrainedDown = "TankOfflineNotDrainedDown",
  TankUnsuitableMaterial = "TankUnsuitableMaterial",
  TankInsufficientAccessForCleaning = "TankInsufficientAccessForCleaning",
  TankLidNotFitted = "TankLidNotFitted",
  TankNoAirVentFitted = "TankNoAirVentFitted",
  TankAirVentNotScreened = "TankAirVentNotScreened",
  TankInsufficientInletMaterial = "TankInsufficientInletMaterial",
  TankInsufficientInletOutletCrossFlow = "TankInsufficientInletOutletCrossFlow",
  TankNoInletIsolationValveFitted = "TankNoInletIsolationValveFitted",
  TankInletIsolationValveNotOperational = "TankInletIsolationValveNotOperational",
  TankInsufficientInletInsulation = "TankInsufficientInletInsulation",
  TankInsufficientOutletMaterial = "TankInsufficientOutletMaterial",
  TankNoOutletIsolationValveFitted = "TankNoOutletIsolationValveFitted",
  TankOutletIsolationValveNotOperational = "TankOutletIsolationValveNotOperational",
  TankInsufficientOutletInsulation = "TankInsufficientOutletInsulation",
  TankNoWarningPipeFitted = "TankNoWarningPipeFitted",
  TankInsufficientWarningPipeMaterial = "TankInsufficientWarningPipeMaterial",
  TankWarningPipeInterconnection = "TankWarningPipeInterconnection",
  TankWarningPipeNotScreened = "TankWarningPipeNotScreened",
  TankInsufficientOverflowMaterial = "TankInsufficientOverflowMaterial",
  TankOverflowInterconnection = "TankOverflowInterconnection",
  TankOverflowNotScreened = "TankOverflowNotScreened",
  TankOpenVentIncorrectlyConfigured = "TankOpenVentIncorrectlyConfigured",
  TankDeadEndNoted = "TankDeadEndNoted",
  TankSuspectedCrossContamination = "TankSuspectedCrossContamination",
  TankHeavyScaleObserved = "TankHeavyScaleObserved",
  TankHeavySedimentObserved = "TankHeavySedimentObserved",
  TankHeavyCorrosionObserved = "TankHeavyCorrosionObserved",
  TankStagnantRedundantOrOversized = "TankStagnantRedundantOrOversized",
  TankHollowLidSupportsFitted = "TankHollowLidSupportsFitted",
  TankRelineInPoorCondition = "TankRelineInPoorCondition",
  TankSwitchValveNotOperational = "TankSwitchValveNotOperational",
  ShowerHeavyScaleDepositsOnHeadNozzles = "ShowerHeavyScaleDepositsOnHeadNozzles",
  ShowerDamagedOrSplitHose = "ShowerDamagedOrSplitHose",
  ShowerCrackedOrDamagedHead = "ShowerCrackedOrDamagedHead",
  ShowerPoorOrUnevenSprayPattern = "ShowerPoorOrUnevenSprayPattern",
  ShowerHoseExcessivelyLong = "ShowerHoseExcessivelyLong",
  ShowerHoseArrangementTrapsWater = "ShowerHoseArrangementTrapsWater",
  ShowerHeadHoseNotSuitableForApplication = "ShowerHeadHoseNotSuitableForApplication",
  Other = "Other"
}

export enum TemperatureTakenFrom {
  DirectWater = "DirectWater",
  BrassFitting = "BrassFitting",
  CopperPipe = "CopperPipe"
}

export enum NonConformityStatus {
  Open = "Open",
  Quoted = "Quoted",
  InProgress = "In-Progress",
  Complete = "Complete",
  Closed = "Closed"
}

export enum Severity {
  Unassigned = "Unassigned",
  Low = "Low",
  Medium = "Medium",
  High = "High"
}
